// import React from "react";
// import Navbar from "./Navbar";
// import Footer from "./Footer";
// import banner1 from "../assets/images/condition.jpg";
// import Whatsapp from "../components/Whatsapp";
// import "../assets/css/style.css";

// const Termsandconditions = () => {
//   return (
//     <div>
//       <Navbar />
//       <div className="project-banner" style={{ backgroundImage: `url(${banner1})` }}></div>

//       <div className=" privacy-policy-container w-full sm:max-w-4xl mx-auto p-4 sm:p-8 shadow-lg rounded-lg bg-white">
//         <h2 className="text-2xl sm:text-3xl font-bold mb-4 sm:mb-6 text-gray-800 text-left">Terms and Conditions</h2>
//         <p className="text-base sm:text-lg text-gray-700 leading-relaxed fs-5">
//         Welcome to Murali Krishna Estate. These Terms & Conditions outline the rules and regulations for using our website and services.
//         By accessing this website, you accept these terms in full. If you do not agree, please do not use our services.
//         </p>

//         <h3 className="text-xl sm:text-2xl font-semibold mt-4 sm:mt-6 text-gray-800">User Eligibility</h3>
//         <ul className="list-disc pl-4 sm:pl-6 mt-2 text-base sm:text-lg text-gray-700 leading-relaxed fs-5">
//         <li>1. Users must be at least 18 years old to use our platform.</li>
//         <li>2. By using this site, you confirm that all information provided is accurate and lawful.</li>
//         </ul>

//         <h3 className="text-xl sm:text-2xl font-semibold mt-4 sm:mt-6 text-gray-800">Property Listings & Accuracy</h3>
//         <ul className="list-disc pl-4 sm:pl-6 mt-2 text-base sm:text-lg text-gray-700 leading-relaxed fs-5">
//         <li>All property listings are provided for informational purposes only.</li>
//             <li>1. Murali Krishna Estate does not guarantee the accuracy, completeness, or availability of listed properties.</li>
//             <li>2. Prices, availability, and terms are subject to change without notice.</li>
//             <li>3. Sellers and agents are responsible for ensuring that the property details are accurate.</li>
//         </ul>

//         <h3 className="text-xl sm:text-2xl font-semibold mt-4 sm:mt-6 text-gray-800">Transactions & Agreements</h3>
//         <ul className="list-disc pl-4 sm:pl-6 mt-2 text-base sm:text-lg text-gray-700 leading-relaxed fs-5">
//         <li>Murali Krishna Estate acts as a platform connecting buyers, sellers, and agents. We do not participate in the transactions directly.</li>
//             <li>1. All real estate transactions are subject to separate agreements between the involved parties.</li>
//             <li>2. We are not responsible for any disputes arising from transactions conducted through our platform.</li>
//         </ul>

//         <h3 className="text-xl sm:text-2xl font-semibold mt-4 sm:mt-6 text-gray-800">User Responsibilities</h3>
//         <ul className="list-disc pl-4 sm:pl-6 mt-2 text-base sm:text-lg text-gray-700 leading-relaxed fs-5">
//             <li>1. Users agree to use the platform for lawful purposes only.</li>
//             <li>2. Any fraudulent activity, misrepresentation, or illegal use of the platform is strictly prohibited.</li>
//             <li>3. Users must not upload false or misleading information.</li>
//         </ul>

//         <h3 className="text-xl sm:text-2xl font-semibold mt-4 sm:mt-6 text-gray-800">Intellectual Property Rights</h3>
//         <p className="list-disc pl-4 sm:pl-6 mt-2 text-base sm:text-lg text-gray-700 leading-relaxed fs-5">
//         All content on this site, including text, images, and branding, is the property of Murali Krishna Estate.
//         Unauthorized use, reproduction, or distribution is prohibited.
//         </p>

//         <h3 className="text-xl sm:text-2xl font-semibold mt-4 sm:mt-6 text-gray-800">Limitation of Liability</h3>
//         <p className="text-base sm:text-lg text-gray-700 leading-relaxed fs-5">
//         Murali Krishna Estate is not liable for any direct or indirect damages resulting from the use of our platform, including but not limited to:
//         </p>
//         <ul className="list-disc pl-4 sm:pl-6 mt-2 text-base sm:text-lg text-gray-700 leading-relaxed fs-5">
//             <li>1.  Errors or inaccuracies in property listings.</li>
//             <li>2.  Delays in transactions.</li>
//             <li>3.  Disputes between buyers, sellers, or agents.</li>
//         </ul>

//         <h3 className="text-xl sm:text-2xl font-semibold mt-4 sm:mt-6 text-gray-800">Privacy Policy</h3>
//         <p className="text-base sm:text-lg text-gray-700 leading-relaxed fs-5">
//         Your use of this website is also governed by our <strong>Privacy Policy</strong>, which details how we collect, use, and protect your data.
//         </p>

//         <h3 className="text-xl sm:text-2xl font-semibold mt-4 sm:mt-6 text-gray-800">Third-Party Links</h3>
//         <p className="text-base sm:text-lg text-gray-700 leading-relaxed fs-5">
//         Our website may contain links to third-party websites. We do not control their content and are not responsible for their privacy policies or terms.
//         </p>

        
//         <h3 className="text-xl sm:text-2xl font-semibold mt-4 sm:mt-6 text-gray-800">Termination of Use</h3>
//         <p className="text-base sm:text-lg text-gray-700 leading-relaxed fs-5">
//         We reserve the right to terminate or suspend any user's access to our platform for violations of these terms.
//         </p>
//         <p className="text-base sm:text-lg text-gray-700 leading-relaxed fs-5">
//         Such actions may be taken without prior notice.
//         </p>

//         <h3 className="text-xl sm:text-2xl font-semibold mt-4 sm:mt-6 text-gray-800"> Amendments to Terms</h3>
//         <p className="text-base sm:text-lg text-gray-700 leading-relaxed fs-5">
//         Murali Krishna Estate reserves the right to update these Terms & Conditions at any time. Continued use of our services after changes take effect constitutes acceptance of the new terms.
//         </p>

//         <h3 className="text-xl sm:text-2xl font-semibold mt-4 sm:mt-6 text-gray-800">Governing Law</h3>
//         <p className="text-base sm:text-lg text-gray-700 leading-relaxed fs-5">
//         These terms are governed by the laws of India. Any disputes shall be resolved in the courts of Andhra Pradesh.
//         </p>

//         <h3 className="text-xl sm:text-2xl font-semibold mt-4 sm:mt-6 text-gray-800">Contact Us</h3>
//         <p className="text-base sm:text-lg text-gray-700 leading-relaxed fs-5">
//         If you have any questions about these Terms & Conditions, you can reach us at:
//         </p>
//         <ul className="list-disc pl-4 sm:pl-6 mt-2 text-base sm:text-lg text-gray-700 leading-relaxed fs-5">
//         <li>Phone: <strong>8333939888, 9666047773</strong></li>
//         </ul>
//       </div>
//       <Whatsapp />
//       <Footer />
//     </div>
//   );
// };
// export default Termsandconditions;








import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import banner1 from "../assets/images/condition.jpg";
import Whatsapp from "../components/Whatsapp";
import "../assets/css/style.css";

const Termsandconditions = () => {
  return (
    <div>
      <Navbar />
      <div className="project-banner" style={{ backgroundImage: `url(${banner1})` }}></div>

      <div className="terms-container">
        <h2 className="terms-title">Terms and Conditions</h2>
        <p className="terms-paragraph">
          Welcome to Devi Vinayaka Builders. These Terms & Conditions outline the rules and guidelines for using our
          website and services. By accessing or using our platform, you agree to be bound by these terms. If you do not
          agree, please discontinue use.
        </p>

        <h3 className="terms-subtitle">1. User Eligibility</h3>
        <ul className="terms-list">
          <li>1. Users must be at least 18 years old.</li>
          <li>2. All information provided must be true, lawful, and up-to-date.</li>
        </ul>

        <h3 className="terms-subtitle">2. Property Listings & Accuracy</h3>
        <ul className="terms-list">
          <li>1. All listings are provided for informational purposes only.</li>
          <li>2. We do not guarantee the accuracy, completeness, or availability of listings.</li>
          <li>3. Prices and availability may change without prior notice.</li>
          <li>4. Sellers and agents are responsible for accurate property data.</li>
        </ul>

        <h3 className="terms-subtitle">3. Transactions & Agreements</h3>
        <ul className="terms-list">
          <li>1. We act solely as a platform to connect buyers, sellers, and agents.</li>
          <li>2. All transactions are independently managed by the parties involved.</li>
          <li>3. We are not liable for disputes or agreements made through the platform.</li>
        </ul>

        <h3 className="terms-subtitle">4. User Responsibilities</h3>
        <ul className="terms-list">
          <li>1. Users must not engage in fraudulent or illegal activities on the platform.</li>
          <li>2. Users must not submit false or misleading property information.</li>
          <li>3. Misuse may lead to suspension or termination of access.</li>
        </ul>

        <h3 className="terms-subtitle">5. Intellectual Property</h3>
        <p className="terms-list">
             All content on this platform including but not limited to text, logos, graphics, images, icons, layout, and 
             design is the exclusive property of Devi Vinayaka Builders. This content is protected under applicable 
             copyright and trademark laws.
          Any unauthorized reproduction, modification, distribution, transmission, display, or performance of the 
              content, in whole or in part, is strictly prohibited without prior written permission from Devi Vinayaka Builders 
              Projects.
              </p>

        <h3 className="terms-subtitle">6. Limitation of Liability</h3>
        <p className="terms-paragraph">We are not liable for any direct or indirect damages resulting from:</p>
        <ul className="terms-list">
          <li>1. Incorrect or outdated property information</li>
          <li>2. Transaction delays or failures</li>
          <li>3. Conflicts between buyers, sellers, or third parties</li>
        </ul>

        <h3 className="terms-subtitle">7. Privacy Policy</h3>
        <p className="terms-paragraph">
        Your data is handled in accordance with our Privacy Policy. By using our platform, you agree to how we collect, 
        use, and safeguard your personal information.
        </p>

        <h3 className="terms-subtitle">8. Third-Party Links</h3>
        <p className="terms-paragraph">
        Our website may include links to external websites or services operated by third parties. These are provided for user convenience only.
We do not have control over the content, security, or privacy policies of these websites, and we disclaim any responsibility for them.
Engagement with third-party services is entirely at the user's own risk.
        </p>

        <h3 className="terms-subtitle">9. Termination</h3>
        <p className="terms-paragraph">
          We reserve the right to suspend or terminate access to users who violate these Terms & Conditions, with or
          without prior notice.
        </p>

        <h3 className="terms-subtitle">10. Changes to Terms</h3>
        <p className="terms-paragraph">
        We may update or amend these Terms & Conditions at any time, with or without notice. It is the user's responsibility to review them periodically.
        Continued use of our website and services after modifications implies acceptance of the updated terms.
        </p>

        <h3 className="terms-subtitle">11. Contact Us</h3>
        <p className="terms-paragraph">For any questions regarding these Terms & Conditions, you may contact us at:</p>
        <ul className="terms-list">
          <li>Phone: <strong>8977060666,6305252452</strong></li>
        </ul>
      </div>
      <Whatsapp />
      <Footer />
    </div>
  );
};
export default Termsandconditions;
